import { _t } from 'utils/translation';

export const AUTO_SCALING_POLICY_METRIC = {
  INSTANCE_CPU_UTILIZATION_AVERAGE: _t('AUTO_SCALE.GROUPS.OPTIONS.METRIC.INSTANCE_CPU_UTILIZATION_AVERAGE'),
  INSTANCE_NETWORK_IN_BYTES: _t('AUTO_SCALE.GROUPS.OPTIONS.METRIC.INSTANCE_NETWORK_IN_BYTES'),
  INSTANCE_NETWORK_IN_PACKETS: _t('AUTO_SCALE.GROUPS.OPTIONS.METRIC.INSTANCE_NETWORK_IN_PACKETS'),
  INSTANCE_NETWORK_OUT_BYTES: _t('AUTO_SCALE.GROUPS.OPTIONS.METRIC.INSTANCE_NETWORK_OUT_BYTES'),
  INSTANCE_NETWORK_OUT_PACKETS: _t('AUTO_SCALE.GROUPS.OPTIONS.METRIC.INSTANCE_NETWORK_OUT_PACKETS'),
};

export const AUTO_SCALING_POLICY_ACTION_AMOUNT_TYPE = {
  ABSOLUTE: _t('AUTO_SCALE.GROUPS.OPTIONS.AMOUNT_TYPES.ABSOLUTE'),
  PERCENTAGE: _t('AUTO_SCALE.GROUPS.OPTIONS.AMOUNT_TYPES.PERCENTAGE'),
};

export const AUTO_SCALING_POLICY_METRIC_UNITS = {
  TOTAL: _t('AUTO_SCALE.GROUPS.OPTIONS.UNITS.TOTAL'),
  PER_SECOND: _t('AUTO_SCALE.GROUPS.OPTIONS.UNITS.PER_SECOND'),
  PER_MINUTE: _t('AUTO_SCALE.GROUPS.OPTIONS.UNITS.PER_MINUTE'),
  PER_HOUR: _t('AUTO_SCALE.GROUPS.OPTIONS.UNITS.PER_HOUR'),
};

export const AUTO_SCALING_TERMINATION_POLICIES = {
  RANDOM: _t('AUTO_SCALE.GROUPS.OPTIONS.TERMINATION_POLICIES.RANDOM'),
  OLDEST_SERVER_FIRST: _t('AUTO_SCALE.GROUPS.OPTIONS.TERMINATION_POLICIES.OLDEST_SERVER_FIRST'),
  NEWEST_SERVER_FIRST: _t('AUTO_SCALE.GROUPS.OPTIONS.TERMINATION_POLICIES.NEWEST_SERVER_FIRST'),
};
